import { gql } from 'urql';

export const ChatEvent = gql`
  subscription onChatEvent {
    onChatEvent {
      __typename
      id
      sender
      eventType
      message
      createdAt
      sessionId
      content {
        ... on ChatContentMessage {
          __typename
          message
        }
        ... on ChatContentHtml {
          __typename
          html
        }
        ... on ChatContentLexBotOption {
          __typename
          message
          action {
            ... on ChatBotAction {
              id
              copy
              type
              value
              __typename
            }
            ... on ChatBotDeepLinkAction {
              id
              copy
              type
              link
              __typename
            }
          }
        }
      }
    }
  }
`;

export default ChatEvent;
